import { graphql } from 'react-relay';

export const simpleApply = graphql`
  mutation simpleApplyMutation($code: String!, $phoneNumber: String, $bank: String, $accountOwner: String, $accountNo: String) {
    simpleApply(input: { code: $code, phoneNumber: $phoneNumber, bank: $bank, accountOwner: $accountOwner, accountNo: $accountNo }) {
      result
      errors {
        code
        message
      }
    }
  }
`;
